import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { keyPairUnitConfig, tokens, BLACK, GREEN_500, YELLOW_500, RED_500 } from '../../constants';
export var getKeyPairUnitStyles = (props, isLargeScreen) => {
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'horizontal' : _props$layout,
    _props$isReverse = props.isReverse,
    isReverse = _props$isReverse === void 0 ? false : _props$isReverse,
    column = props.column;
  return StyleSheet.create({
    container: {
      width: 'auto',
      display: 'flex',
      flexDirection: layout === 'horizontal' ? 'row' : 'column',
      flexWrap: 'wrap'
    },
    innerContainer: {
      display: 'flex',
      flexDirection: 'row',
      paddingVertical: tokens.spacing.SPACING_4
    },
    keyValueContainer: {
      flexDirection: !isReverse ? 'column' : 'column-reverse'
    },
    keyContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: isReverse ? 0 : isLargeScreen ? tokens.spacing.SPACING_8 : tokens.spacing.SPACING_4
    },
    valueDiscountContainer: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    valueContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: isReverse ? tokens.spacing.SPACING_4 : isLargeScreen ? tokens.spacing.SPACING_8 : tokens.spacing.SPACING_0
    },
    divider: {
      marginLeft: tokens.spacing.SPACING_2
    },
    leftSafeSpacing: {
      marginLeft: tokens.spacing.SPACING_8
    },
    iconContainer: {
      alignSelf: 'flex-end',
      marginLeft: tokens.spacing.SPACING_16
    },
    topMarginContainer: {
      marginTop: tokens.spacing.SPACING_8
    },
    flexDirectionRow: {
      flexDirection: 'row'
    },
    logoStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    fullWidth: {
      width: '100%'
    },
    avatarImgStyles: Object.assign({}, column === 1 && {
      position: 'absolute',
      right: -4
    })
  });
};
export var getKeyPairStatusColors = function getKeyPairStatusColors(status) {
  if (status === void 0) {
    status = 'default';
  }
  var data = {
    default: {
      color: BLACK
    },
    success: {
      color: GREEN_500
    },
    warning: {
      color: YELLOW_500
    },
    danger: {
      color: RED_500
    }
  };
  return data === null || data === void 0 ? void 0 : data[status];
};
export var getKeyPairUnitProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(keyPairUnitConfig === null || keyPairUnitConfig === void 0 ? void 0 : keyPairUnitConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.keyPairUnit) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};